<div class="pdf-page app-aul-034-24" id="aul03424">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> WATER DAMAGE EXCLUSION</b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    This endorsement modifies insurance provided under the following forms.
    <br />
    CAUSES OF LOSS - SPECIAL FORM
  </p>
  <p class="font-small">
    The following <b>Water Damage Exclusion</b> is added <b>B. Exclusions:</b>
  </p>
  <p class="font-small">
    <b>Water Damage</b>
  </p>
  <p class="font-small">
    a. Water Damage, meaning accidental discharge or leakage of water or steam
    as the direct result of the breaking apart or cracking of a plumbing,
    heating, air conditioning or other system or appliance, that is located on
    the described premises and contains water or steam.
  </p>
  <p class="font-small">
    This Water Damage Exclusions also excludes loss or damage from:
  </p>
  <div class="font-small ps-10">
    <ol class="custom-list">
      <li>
        Discharge or leakage from:
        <ol>
          <li>An Automatic Sprinkler System;</li>
          <li>
            A sump or related equipment and parts, including overflow due to
            sump pump failure or excessive volume of water; or
          </li>
          <li>
            Roof drains, gutters, downspouts or similar fixtures or equipment.
          </li>
        </ol>
      </li>
      <li>The cost to repair any defect that caused the loss or damage;</li>
      <li>
        Loss or damage caused by or resulting from continuous or repeated
        seepage or leakage of water, or the presence or condensation of
        humidity, moisture or vapor, that occurs over a period of 14 days or
        more; or
      </li>
      <li>Loss or damage caused by or resulting from freezing.</li>
    </ol>
  </div>

  <p class="font-small">
    b. If the building or structure containing the system or appliance is
    Covered Property, we will not pay the cost to tear out and replace any part
    of the building or structure to repair damage to the system or appliance
    from which the water or steam escapes and we will not pay the cost to repair
    any defect that caused the loss or damage.
  </p>
  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged.</b>
  </p>
  <br />
  <br />
  <br />
</div>
